import { Global } from "@emotion/react";
import { Fragment } from "react";
import tw, { css, GlobalStyles as BaseStyles } from "twin.macro";
// import { useTernaryDarkMode } from "usehooks-ts";

const customStyles = css`
  html,
  body,
  #root {
    ${tw`h-full `}
  }

  html {
    overflow: hidden;
  }

  body {
    ${tw`bg-neutral-50 text-on-background transition duration-200 text-base md:text-sm`}
  }
`;

const GlobalStyles = () => {
  //#region Dark mode management
  // const { isDarkMode } = useTernaryDarkMode();
  // useEffect(() => {
  //   const root = window.document.documentElement;
  //   root.classList.remove(isDarkMode ? "light" : "dark");
  //   root.classList.add(isDarkMode ? "dark" : "light");
  // }, [isDarkMode]);

  // useEffect(() => {
  //   const root = window.document.documentElement;
  //   root.classList.add("light");
  // }, []);
  //#endregion Dark mode management

  return (
    <Fragment>
      <BaseStyles />
      <Global styles={customStyles} />
    </Fragment>
  );
};

export default GlobalStyles;
